import React from 'react';
import {hasValue} from '@packages/utilities/string-utils';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import {appendUserInputClasses} from '@packages/systems/users/utils/universalUtils';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {
  getInPojo,
  getString,
  getArrayOrElse,
} from '@packages/utilities/data-utils';

interface OptionData {
  v?: string;
  t?: string;
}

const createOption = (option: unknown, index: number) => {
  if (!option || typeof option !== 'object') return null;
  const opt = option as OptionData;
  const v = opt?.v;
  const text = opt?.t;
  const isValued = v ? hasValue(v) : false;
  return (
    <option key={index} value={isValued ? v : ''}>
      {isValued ? text : ''}
    </option>
  );
};

const UserFormSelect = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const runtimeEnvironment = useRuntimeEnvironment();
    const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

    const selectClasses = classes.push('w-select');
    const inputClasses = appendUserInputClasses(data, selectClasses);

    const field = getString(getInPojo(data, ['users', 'field']));
    const fieldType = getString(getInPojo(data, ['users', 'fieldType']));

    const attributeWithField = field
      ? attributes.set(USYS_DATA_ATTRS.field, field)
      : attributes;

    const optionsData = getArrayOrElse(getInPojo(data, ['form', 'opts']), [{}]);

    return (
      <select
        {...generateAttributes(
          fieldType
            ? attributeWithField.set(USYS_DATA_ATTRS.fieldType, fieldType)
            : attributeWithField,
          inputClasses
        )}
      >
        {createOption(optionsData[0], 0)}
        {isDesigner ? (
          <>
            <option key={1} value="">
              Option 1
            </option>
            <option key={2} value="">
              Option 2
            </option>
            <option key={3} value="">
              Option 3
            </option>
          </>
        ) : null}
      </select>
    );
  }
);

const config = Atom.create({
  displayName: 'Select Field',
  constraints: {
    ancestors: [
      {
        is: ['UserSignUpForm', 'UserAccountForm'],
        name: 'User Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Select')),
  },
  showEmpty: false,
  render: UserFormSelect,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('UserFormSelect'))
  ),
});

export default config;
